import script from "./ValidatorsConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorsConfig.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorsConfig.vue?vue&type=style&index=0&id=b59d8506&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b59d8506"]])

export default __exports__